import { api } from "@king-ict/eupisi-ui/utils";

import { MunicipalityCodeBook } from "../../models/Municipality";

const municipalitiesUrlPrefix: string = "municipalities";

export const searchMunicipalities = async (search: string, countyIds: number[] | undefined) => {
    let url = `${municipalitiesUrlPrefix}`;
    let request: any = { search: search }
    if (countyIds){
        request.countyIds = countyIds;
    }
    return api.get(url, request) as Promise<MunicipalityCodeBook[]>
}

export const getMunicipalityById = async (id: number) => {
    return api.get(
        `${municipalitiesUrlPrefix}/${id}`
    ) as Promise<MunicipalityCodeBook>
}

export const getMunicipalityByTownId = async (id: number) => {
  return api.get(
    `${municipalitiesUrlPrefix}/by-town/${id}`
  ) as Promise<MunicipalityCodeBook>
}